import React from 'react';
import { Row, Col, Button } from "reactstrap";
import { useNavigate } from 'react-router-dom';
import { APPConstants } from '../../../constants/app';
import Styles from '../Login.module.css';
import Logo from '../../../assests/logo.svg';
import BuildeLabel from '../../../assests/builde_label.svg';
import Footer from '../../Footer';

function BaseLogin({ onHandleLogin, onHandleSignUp, allowContinueWithoutAccount}) {
  const navigate = useNavigate();

  return (
    <div className={Styles.background}>
      <Row className='h-25 gx-0' />
      <Row className='h-25 gx-0'>
        <Col sm='12' className='text-center'>
          <img src={Logo} alt='Logo' />
        </Col>
        <Col sm='12' className='text-center'>
          <img src={BuildeLabel} alt='Logo' />
        </Col>
      </Row>
      <Row className='h-25 gx-0'>
        <Col sm="4" className='d-none d-xl-block' />
        <Col sm="4">
          <Row className='h-100 align-items-end gx-0'>
            <Col className='ms-3 me-3'>
              <Button
                color='light'
                className={Styles.loginButton + ' w-100 bg-white text-black'}
                onClick={() => onHandleLogin()}
              >
                Log in
              </Button>
            </Col>
          </Row>
        </Col>
        <Col sm="4" className='d-none d-xl-block' />
      </Row>
      <Row className='h-25 gx-0'>
        <Col sm="4" className='d-none d-xl-block' />
        <Col sm="4">
          <Row className='h-50 align-items-start gx-0'>
            <Col className='mt-3 ms-3 me-3'>
              <Button
                className={Styles.signUpButton + ' w-100'}
                onClick={() => onHandleSignUp()}
              >
                Sign Up
              </Button>
            </Col>
          </Row>
          {
            allowContinueWithoutAccount &&
            <Row className='h-50 align-items-start gx-0'>
              <Col className='mt-3 ms-3 me-3'>
                <Button
                  color='link'
                  className={Styles.continueWithoutAccountButton + ' w-100 text-white'}
                  onClick={() => navigate(APPConstants.APP_BASE_URI)}
                >
                  Continue without account
                </Button>
              </Col>
            </Row>
          }
        </Col>
        <Col sm="4" className='d-none d-xl-block' />
      </Row>
      <Footer hideLinks={true} />
    </div>
  );
}

export default BaseLogin;
